// extracted by mini-css-extract-plugin
export default {"Calculator":"Calculator_Calculator__g3xfy","CalculatorStory":"Calculator_CalculatorStory__O71O9"};